import { Container, Row } from 'react-bootstrap';

const Home = () => {
  return (
    <> 
      <div className="container-fluid px-0 mx-0">
        <section class="scrolling-background"></section>
      </div>
      <div class="container-fluid">
        <section id="how-it-works">

          <div class="jumbotron jumbotron-fluid mt-5 mb-5 pt-3 pb-3">
            <div class="container">
              <h1 class="display-4">Think it. Chirp it. Consider it done!</h1>
              <p class="lead">
                ChirpTask is your on-demand task service that understands what you need from just a short message. Whether it’s building furniture, prepping meals, running errands, or combining them all—our AI breaks it down and gets it done.</p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 step">
              <div class="card mb-3">
                <div class="card-body">
                  <h3>Describe Your Task</h3>
                  <p>Just type your request like a tweet—“pick up groceries, cook dinner, and clean the kitchen.” That’s all we need.</p>
                </div>
              </div>
            </div>
            <div class="col-md-6 step">
              <div class="card mb-3">
                <div class="card-body">
                  <h3>We Break it Down</h3>
                  <p>Our AI transforms your message into structured, step-by-step actions. Each step is clear, priced, and ready to go.</p>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 step">
              <div class="card mb-3">
                <div class="card-body">
                  <h3>Instant Pricing</h3>
                  <p>No quotes, no guessing. You see upfront pricing the moment you submit your task, based on transparent rates per step.</p>
                </div>
              </div>
            </div>
            <div class="col-md-6 step">
              <div class="card mb-3">
                <div class="card-body">
                  <h3>4. Dispatch a Chirper</h3>
                  <p>We send the right Chirper—like hailing an Uber for your to-do list. You’ll get real-time status updates as each step is completed.</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="why-chirptask">
          <ul class="list-group mt-5 mb-5">
            <li class="list-group-item active" style={{backgroundColor: '#17436D', borderColor: '#17436D'}}>Why Choose ChirpTask?</li>
            <li class="list-group-item"><strong>Smarter Tasks:</strong> AI breaks down even complex requests into manageable steps so we can match the perfect Chirper for the job.</li>
            <li class="list-group-item"><strong>Transparent Pricing:</strong> No awkward requests for quotes or having to estimate the hours needed. Know the price before you commit.</li>
            <li class="list-group-item"><strong>Real-Time Updates:</strong> Follow your task’s progress in real time, step by step. Useful if you aren't there in person to supervise.</li>
            <li class="list-group-item"><strong>Faster Help:</strong> We'll match you with a Chirper in minutes — not hours or days, so your task gets done right away.</li>
            <li class="list-group-item"><strong>Higher Quality:</strong> Many Chirpers are full or parttime employees, not just contract gig workers, so you are getting a dedicated, high quality worker.</li>
          </ul>
        </section>
      </div>
    </>
  );
};

export default Home;




